import './Work.css';
import { useEffect } from 'react';
import { Link } from 'react-router';
import { PROJECTS } from '../../config/projects';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function Work() {
  useEffect(() => {
    document.title = 'Work | Phoenix Unity Designs';
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.work.title}
        description={SEO_CONFIG.work.description}
        keywords={SEO_CONFIG.work.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.work.path)}
        ogUrl={getCanonicalUrl(SEO_CONFIG.work.path)}
      />
      <main id="main-content" tabIndex="-1" className='Work page-container'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            {/* <h1>Work</h1> */}
            {/* <h1>Design,<br />Without Permission.</h1> */}
            {/* <h1>Designed With Intent.<br />Built to Last.</h1> */}
            {/* <h1>Where Craft Meets Conviction.</h1> */}
            {/* <h1>Quality Isn’t a Feature. It’s the Point.</h1> */}
            <h1>
              <span className='h-row'>
                <span className='h-word'>Question</span> <span className='h-word'>Everything.</span></span><br />
                <span className='h-row'><span className='h-word'>Design</span> <span className='h-word'>Something</span> <span className='h-word'>Better.</span>
              </span>
            </h1>
            {/* <h1>Challenging convention to reveal opportunity and build brands with purpose.</h1> */}
            <ul className='projects-list'>
              {PROJECTS.map(project => (
                <li key={project.id} className={`project-card ${project.className || ''}`}>
                  <img src={project.image} alt={project.pageTitle} />
                  <h2>{project.pageTitle}</h2>
                  <div className="project-description">
                    <span>{project.brand}</span>
                    <p>{project.description}</p>
                  </div>
                  <Link to={project.link} aria-label={`View project ${project.pageTitle}`}>View</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default Work;
